/**
 * NOTE: this uid is also hardcoded in the firestore security rules!
 *
 * @deprecated use `ANON_ROLE_UID` from `@buildwithflux/constants` instead
 */
export const ANON_ROLE_UID = "0338f920-f103-45be-9462-2cae879caa37";
